<mat-card>
  <app-card-header
    title="Enviar Comando"
    icono="send"
    [botonCerrar]="true"
    (cerrar)="onClose()"
  ></app-card-header>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <mat-card-content class="card-content-crear">
      <!-- Tabs -->
      <mat-tab-group
        [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="onTabChange($event)"
      >
        <!-- Tab Cargados -->
        <mat-tab label="Cargados">
          <div style="padding-top: 1em">
            <ng-select
              [items]="codigosEntrada"
              bindValue="codigo"
              bindLabel="descripcion"
              formControlName="codigo"
              placeholder="Seleccioná un comando"
              [clearable]="false"
              appendTo="body"
              notFoundText="Sin resultados"
            >
              <!-- Template para las opciones -->
              <ng-template ng-option-tmp let-item="item">
                <div style="display: flex; gap: 8px">
                  <span>{{ item.descripcion }}</span>
                  <span>-</span>
                  <span>{{ item.codigo }}</span>
                </div>
              </ng-template>

              <!-- Template para el valor seleccionado -->
              <ng-template ng-label-tmp let-item="item">
                <div style="display: flex; gap: 8px">
                  <span>{{ item.descripcion }}</span>
                  <span>-</span>
                  <span>{{ item.codigo }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
        </mat-tab>

        <!-- Tab Personalizado -->
        <mat-tab label="Personalizado">
          <div style="padding-top: 1em">
            <mat-form-field style="width: 100%">
              <mat-label>Código Personalizado</mat-label>
              <input
                matInput
                formControlName="codigoPersonalizado"
                placeholder="Ingresá el código personalizado"
              />
            </mat-form-field>
          </div>
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <app-button
        matType="mat-fab extended"
        color="neutral"
        (click)="onClose()"
        text="Cancelar"
        icon="close"
      ></app-button>
      <app-button
        matType="mat-fab extended"
        color="primary"
        [disabled]="!isFormValid || loading"
        text="Enviar"
        icon="send"
        type="submit"
      ></app-button>
    </mat-card-actions>
  </form>
</mat-card>
